export let stats_v3;
export let sn_url;
export let env_url;
export let config_url;
export let brightcode_player_id;
export let broadcast_api_url;
export let gallery_player_id;
export let solr_search_url;
export let solr_global_url;
export let sn_stories_tax_url;
export let sn_nav_url;
export let wp_api_video_slug;
export let wp_api_video_page;
export let igh_url;
export let series_coverage_url;
export let personalization_url;
export let brightcove_account_id_nhl_clips;
export let eas_authorization_path;
export let eas_client_id;
export let eas_redirect_url;
export let eas_secure_domain;

export const brightcove_account_id = '1704050871';

export const getStatsUrl = () => {
	const env = process.env.REACT_APP_ENV;
	if (env === 'integration' || env === 'local') {
		return 'https://int-stats-api.sportsnet.ca';
	} else if (env === 'staging') {
		return 'https://staging-stats-api.sportsnet.ca';
	} else {
		return 'https://stats-api.sportsnet.ca';
	}
};

export const getIghUrl = () => {
	const env = process.env.REACT_APP_ENV;
	if (env === 'integration' || env === 'local') {
		return 'https://int-stats-api.sportsnet.ca';
	} else {
		return 'https://stats-api.sportsnet.ca';
	}
};

export const getPlayerImageBaseURL = leagueProps => {
	const league = leagueProps ? leagueProps : window.location.pathname.split('/')[2];
	const env = process.env.REACT_APP_ENV;
	const leagues = ['NHL', 'MLB', 'NBA', 'WNBA', 'NFL']; // SR Migration stat player headshots

	if (leagues.includes(league.toUpperCase())) {
		if (env === 'integration' || env === 'local') {
			return `https://int-images.sportsnet.ca/player_headshots/${league.toUpperCase()}`;
		} else if (env === 'staging') {
			return `https://images.sportsnet.ca/player_headshots/${league.toUpperCase()}`;
		} else {
			return `https://images.sportsnet.ca/player_headshots/${league.toUpperCase()}`; //TODO: this should change to images.sportsnet.ca once prod images are migrated.
		}
	} else {
		return 'https://assets1.sportsnet.ca/wp-content/uploads/players';
	}
};

if (process.env.REACT_APP_ENV === 'staging') {
	stats_v3 = 'https://staging-stats-api.sportsnet.ca';
	sn_url = 'https://staging-www.sportsnet.ca';
	env_url = 'https://d2il0j1qr7e4lc.cloudfront.net';
	config_url = 'https://static-tower.sportsnet.ca/';
	brightcode_player_id = 'By5x5ZRLZ';
	gallery_player_id = 'OxLgkAih9';
	broadcast_api_url = 'https://staging-schedule-admin.sportsnet.ca/v1';
	solr_search_url = 'https://us-east-1.websolr.com/solr/a9c57d4ef328';
	solr_global_url = 'https://us-east-1.websolr.com/solr/b96de0824357';
	sn_stories_tax_url = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/posts-by-tax';
	sn_nav_url = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/menu';
	wp_api_video_page = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/video-page';
	series_coverage_url = 'https://staging-www.sportsnet.ca/wp-json/sportsnet/v1/series-covarage';
	wp_api_video_slug = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/video-by-slug/?slug=';
	igh_url = getIghUrl();
	personalization_url = 'https://stats.sportsnet.ca/kremer';
	brightcove_account_id_nhl_clips = '3840518750001';
	eas_authorization_path = 'api/v2/login/direct/eas/authorize';
	eas_client_id = 'e5c3fd29-84b1-40ee-a7b4-85e1e67b1f11';
	eas_redirect_url = 'https://staging-www.sportsnet.ca/eas_callback';
	eas_secure_domain = 'https://rogers-qa.transmit.security';
} else if (process.env.NODE_ENV === 'development') {
	stats_v3 = 'https://int-stats-api.sportsnet.ca';
	sn_url = 'https://int-www.sportsnet.ca';
	env_url = 'https://dczu06sbgnaj.cloudfront.net';
	config_url = 'https://int-static-tower.sportsnet.ca/';
	brightcode_player_id = 'SyEJB7ABz';
	gallery_player_id = 'OxLgkAih9';
	broadcast_api_url = 'https://int-schedule-admin.sportsnet.ca/v1';
	solr_search_url = 'https://us-east-1.websolr.com/solr/a9c57d4ef328';
	solr_global_url = 'https://us-east-1.websolr.com/solr/b96de0824357';
	sn_stories_tax_url = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/posts-by-tax';
	series_coverage_url = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/series-covarage';
	sn_nav_url = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/menu';
	wp_api_video_page = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/video-page';
	wp_api_video_slug = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/video-by-slug/?slug=';
	igh_url = getIghUrl();
	personalization_url = 'https://int-stats.sportsnet.ca/kremer';
	brightcove_account_id_nhl_clips = '5413606366001';
	eas_authorization_path = 'api/v2/login/direct/eas/authorize';
	eas_client_id = 'e5c3fd29-84b1-40ee-a7b4-85e1e67b1f11';
	eas_redirect_url = 'https://int-www.sportsnet.ca/eas_callback';
	eas_secure_domain = 'https://rogers-qa.transmit.security';
} else if (process.env.REACT_APP_ENV === 'integration') {
	stats_v3 = 'https://int-stats-api.sportsnet.ca';
	sn_url = 'https://int-www.sportsnet.ca';
	env_url = 'https://dczu06sbgnaj.cloudfront.net';
	config_url = 'https://int-static-tower.sportsnet.ca/';
	brightcode_player_id = 'SyEJB7ABz';
	gallery_player_id = 'OxLgkAih9';
	broadcast_api_url = 'https://int-schedule-admin.sportsnet.ca/v1';
	solr_search_url = 'https://us-east-1.websolr.com/solr/a9c57d4ef328';
	solr_global_url = 'https://us-east-1.websolr.com/solr/b96de0824357';
	sn_stories_tax_url = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/posts-by-tax';
	series_coverage_url = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/series-covarage';
	sn_nav_url = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/menu';
	wp_api_video_page = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/video-page';
	wp_api_video_slug = 'https://int-www.sportsnet.ca/wp-json/sportsnet/v1/video-by-slug/?slug=';
	igh_url = getIghUrl();
	personalization_url = 'https://int-stats.sportsnet.ca/kremer';
	brightcove_account_id_nhl_clips = '5413606366001';
	eas_authorization_path = 'api/v2/login/direct/eas/authorize';
	eas_client_id = 'e5c3fd29-84b1-40ee-a7b4-85e1e67b1f11';
	eas_redirect_url = 'https://int-www.sportsnet.ca/eas_callback';
	eas_secure_domain = 'https://rogers-qa.transmit.security';
} else {
	stats_v3 = 'https://stats-api.sportsnet.ca';
	sn_url = 'https://www.sportsnet.ca';
	env_url = 'https://d2ml1l8vdyfdxz.cloudfront.net';
	config_url = 'https://static-tower.sportsnet.ca/';
	brightcode_player_id = 'SyVBbGuqZ';
	gallery_player_id = 'JCdte3tMv';
	broadcast_api_url = 'https://schedule-admin.sportsnet.ca/v1';
	solr_search_url = 'https://us-east-1.websolr.com/solr/42bf173ecda8';
	solr_global_url = 'https://us-east-1.websolr.com/solr/b7c4528d3f19';
	sn_stories_tax_url = 'https://www.sportsnet.ca/wp-json/sportsnet/v1/posts-by-tax';
	series_coverage_url = 'https://www.sportsnet.ca/wp-json/sportsnet/v1/series-covarage';
	sn_nav_url = 'https://www.sportsnet.ca/wp-json/sportsnet/v1/menu';
	wp_api_video_page = 'https://www.sportsnet.ca/wp-json/sportsnet/v1/video-page';
	wp_api_video_slug = 'https://www.sportsnet.ca/wp-json/sportsnet/v1/video-by-slug/?slug=';
	igh_url = getIghUrl();
	personalization_url = 'https://stats.sportsnet.ca/kremer';
	brightcove_account_id_nhl_clips = '3840518750001';
	eas_authorization_path = 'api/v2/login/direct/eas/authorize';
	eas_client_id = '5abb544e-77db-490a-abb4-fac4d52eb4ba';
	eas_redirect_url = 'https://www.sportsnet.ca/eas_callback';
	eas_secure_domain = 'https://rogers-prd.transmit.security';
}

export const getWsUrl = league => {
	let ws_url = '';

	switch (league) {
		case 'mlb':
			if (process.env.REACT_APP_ENV === 'staging') {
				ws_url = 'wss://stgspnmlb-ws.sportsnet.ca/livetracker';
			} else if (process.env.NODE_ENV === 'development') {
				ws_url = 'wss://stgspnmlb-ws.sportsnet.ca/livetracker';
			} else {
				ws_url = 'wss://prdspnmlb-ws.sportsnet.ca/livetracker';
			}
			break;
		case 'nhl':
			if (process.env.REACT_APP_ENV === 'staging') {
				ws_url = 'wss://stgspnmlb-ws.sportsnet.ca/livetracker';
			} else if (process.env.NODE_ENV === 'development') {
				ws_url = 'wss://stgspnmlb-ws.sportsnet.ca/livetracker';
			} else {
				ws_url = 'wss://prdspnmlb-ws.sportsnet.ca/livetracker';
			}
			break;
		default:
			ws_url = 'wss://stgspnmlb-ws.sportsnet.ca/livetracker';
	}

	return ws_url;
};
